"use client";

import { useIsShopsite } from "@context/DomainContext";
import * as SliderPrimitive from "@radix-ui/react-slider";
import { joinClassNames } from "@utils/helpers";
import * as React from "react";

/**
 * A global slider UI, that can be used for example as a dynamic price slider
 */
const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ className, ...props }, ref) => {
  const isShopsite = useIsShopsite();

  return (
    <SliderPrimitive.Root
      ref={ref}
      className={joinClassNames(
        "relative flex w-full touch-none select-none items-center",
        className ?? ""
      )}
      {...props}
    >
      <SliderPrimitive.Track
        className={joinClassNames(
          "relative h-1.5 w-full grow overflow-hidden rounded-full",
          isShopsite ? "bg-[#FFD3E2]" : "bg-[color:var(--crimson-a3)]"
        )}
      >
        <SliderPrimitive.Range
          className={joinClassNames(
            "absolute h-full",
            isShopsite ? "bg-iticket" : "bg-[color:var(--crimson-9)]"
          )}
        />
      </SliderPrimitive.Track>
      <SliderPrimitive.Thumb
        className={joinClassNames(
          "block h-4 w-4 rounded-full border shadow transition-colors focus-visible:outline-none focus-visible:ring-1 disabled:pointer-events-none disabled:opacity-50",
          isShopsite
            ? "border-iticket/50 bg-background focus-visible:ring-iticket/60"
            : "border-[color:var(--crimson-a9)] bg-[color:var(--gray-1)] focus-visible:ring-[color:var(--crimson-a4)]"
        )}
      />
    </SliderPrimitive.Root>
  );
});
Slider.displayName = SliderPrimitive.Root.displayName;

export default Slider;
